import { CSSObject } from '@chakra-ui/react';

export const InfoExoticsContainer: CSSObject = {
  mt: '1',
  px: '2',
};
